// extracted by mini-css-extract-plugin
export default {"main":"Header_main__19JCc","navholder":"Header_navholder__sTZLP","rightside":"Header_rightside__g+v4l","heading":"Header_heading__Ai2dB","menulink":"Header_menulink__MqEzo"};